import { useEffect, useState } from "react";
import "./home-welcome-hero.css";

const PREFIX = "Êtes-vous";

const AUDIENCES = [
    { label: "automobiliste" },
    { label: "garagiste" },
    { label: "mécanicien" },
    { label: "revendeur de pièces" },
    { label: "une entreprise véhiculée" },
    { label: "chauffeur" }
];

const ORDER_WHEN_PREFIX = "Commandez en étant";

const ORDER_WHEN_LOCATIONS = [
    "au garage",
    "à l'atelier",
    "dans l'embouteillage",
    "à la maison",
    "à la réunion",
    "à l'étranger",
    "déjà dans les bruits"
];

const PLATFORM_ADVANTAGES = [
    {
        type: "static",
        label: "Commandez à toute heure",
        icon: (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 2a10 10 0 0 0-10 10c0 2.4.85 4.6 2.26 6.32L4 20l1.9-.5A9.96 9.96 0 0 0 12 22a10 10 0 0 0 0-20Zm.5 5v5.25l4.25 2.46-.75 1.3L11 13V7h1.5Z" />
            </svg>
        )
    },
    {
        type: "typewriter",
        prefix: ORDER_WHEN_PREFIX,
        words: ORDER_WHEN_LOCATIONS,
        icon: (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7Zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5Z" />
            </svg>
        )
    },
    {
        type: "static",
        label: "Commandez en gros ou en détail",
        icon: (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M4 4h3l2 5h9v2h-1.05l1.45 5.5H7.1L5.65 11H4V4Zm5.2 13.5h7.3l-1.2-4.5H8.4l.8 4.5ZM9 20a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm8 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" />
            </svg>
        )
    },
    {
        type: "static",
        label: "Livraison gratuite*",
        icon: (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M3 6h11v8H3V6Zm12 0h2.2L19 9v5h-4V6ZM5.5 18a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm11 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" />
            </svg>
        )
    },
    {
        type: "static",
        label: "Grand catalogue de pièces automobile",
        icon: (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M4 4h16v2H4V4Zm0 7h16v2H4v-2Zm0 7h10v2H4v-2Z" />
            </svg>
        )
    },
    {
        type: "static",
        label: "Pièces d'origine et adaptables",
        icon: (
            <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="m14.7 6.3 1.4-1.4a3 3 0 0 1 4.2 4.2l-1.4 1.4-2.8-2.8ZM3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25ZM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83Z" />
            </svg>
        )
    }
];

const HERO_ICON = (
    <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M5 11h14l-1.2-3.6A2 2 0 0 0 15.9 6H8.1a2 2 0 0 0-1.9 1.4L5 11Zm-.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm15 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM4 13.5v4.25A1.25 1.25 0 0 0 5.25 19h1A1.25 1.25 0 0 0 7.5 17.75V16h9v1.75A1.25 1.25 0 0 0 17.75 19h1A1.25 1.25 0 0 0 20 17.75V13.5" />
    </svg>
);

const FINAL_ICON = (
    <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M9 16.2 4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2Z" />
    </svg>
);

const FINAL_MESSAGE = "Trouvez et commandez vos pièces sur Global4Automobile.com";
const TYPE_DELAY_MS = 65;
const DELETE_DELAY_MS = 38;
const HOLD_DELAY_MS = 1700;
const CYCLE_PAUSE_MS = 10000;

function useTypewriterCycle(words, { enabled, skipDeleteOnLast = false }) {
    const [wordIndex, setWordIndex] = useState(0);
    const [visibleChars, setVisibleChars] = useState(0);
    const [deleting, setDeleting] = useState(false);

    const currentWord = words[wordIndex] ?? "";
    const isLastWord = wordIndex >= words.length - 1;
    const typedWord = currentWord.slice(0, visibleChars);

    useEffect(() => {
        if (!enabled) {
            return undefined;
        }

        let timeoutId;

        if (!deleting && visibleChars < currentWord.length) {
            timeoutId = window.setTimeout(() => setVisibleChars((count) => count + 1), TYPE_DELAY_MS);
        } else if (!deleting && visibleChars === currentWord.length) {
            timeoutId = window.setTimeout(() => {
                if (skipDeleteOnLast && isLastWord) {
                    return;
                }
                setDeleting(true);
            }, HOLD_DELAY_MS);
        } else if (deleting && visibleChars > 0) {
            timeoutId = window.setTimeout(() => setVisibleChars((count) => count - 1), DELETE_DELAY_MS);
        } else if (deleting && visibleChars === 0) {
            setDeleting(false);
            setWordIndex((index) => (index + 1) % words.length);
        }

        return () => window.clearTimeout(timeoutId);
    }, [currentWord, deleting, enabled, isLastWord, skipDeleteOnLast, visibleChars, wordIndex, words.length]);

    return { typedWord, deleting, visibleChars, currentWord };
}

function AdvantageTypewriterLine({ prefix, words, icon }) {
    const prefersReducedMotion = typeof window !== "undefined"
        && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const maxRoleChars = Math.max(...words.map((word) => word.length));
    const { typedWord, deleting, visibleChars, currentWord } = useTypewriterCycle(words, {
        enabled: !prefersReducedMotion
    });
    const displayWord = prefersReducedMotion ? words[0] : typedWord;
    const showCursor = !prefersReducedMotion;

    return (
        <li className="home-welcome-hero__advantage">
            <span className="home-welcome-hero__advantage-icon">{icon}</span>
            <span className="home-welcome-hero__advantage-copy">
                <span className="home-welcome-hero__advantage-typewriter">
                    <span className="home-welcome-hero__advantage-prefix">{prefix}</span>
                    <span
                        className="home-welcome-hero__advantage-dynamic"
                        style={{ minWidth: `${maxRoleChars}ch` }}
                    >
                        <span className="home-welcome-hero__advantage-role">{displayWord}</span>
                        {showCursor ? (
                            <span className="home-welcome-hero__advantage-cursor" aria-hidden="true">|</span>
                        ) : null}
                    </span>
                </span>
                {!prefersReducedMotion ? (
                    <span className="home-welcome-hero__advantage-sr" aria-live="polite">
                        {prefix}{" "}
                        {visibleChars === currentWord.length && !deleting ? currentWord : displayWord}
                    </span>
                ) : null}
            </span>
        </li>
    );
}

export default function HomeWelcomeHero() {
    const [audienceIndex, setAudienceIndex] = useState(0);
    const [visibleChars, setVisibleChars] = useState(0);
    const [deleting, setDeleting] = useState(false);
    const [finished, setFinished] = useState(false);

    const currentAudience = AUDIENCES[audienceIndex];
    const isLastAudience = audienceIndex >= AUDIENCES.length - 1;
    const typedWord = currentAudience?.label.slice(0, visibleChars) ?? "";
    const showQuestionSuffix = visibleChars === currentAudience.label.length && !deleting;

    useEffect(() => {
        if (finished) {
            return undefined;
        }

        const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (prefersReducedMotion) {
            setFinished(true);
            return undefined;
        }

        const word = currentAudience.label;
        let timeoutId;

        if (!deleting && visibleChars < word.length) {
            timeoutId = window.setTimeout(() => setVisibleChars((count) => count + 1), TYPE_DELAY_MS);
        } else if (!deleting && visibleChars === word.length) {
            timeoutId = window.setTimeout(() => {
                if (isLastAudience) {
                    setFinished(true);
                } else {
                    setDeleting(true);
                }
            }, HOLD_DELAY_MS);
        } else if (deleting && visibleChars > 0) {
            timeoutId = window.setTimeout(() => setVisibleChars((count) => count - 1), DELETE_DELAY_MS);
        } else if (deleting && visibleChars === 0) {
            setDeleting(false);
            setAudienceIndex((index) => index + 1);
        }

        return () => window.clearTimeout(timeoutId);
    }, [audienceIndex, currentAudience.label, deleting, finished, isLastAudience, visibleChars]);

    useEffect(() => {
        if (!finished) {
            return undefined;
        }

        const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (prefersReducedMotion) {
            return undefined;
        }

        const timeoutId = window.setTimeout(() => {
            setAudienceIndex(0);
            setVisibleChars(0);
            setDeleting(false);
            setFinished(false);
        }, CYCLE_PAUSE_MS);

        return () => window.clearTimeout(timeoutId);
    }, [finished]);

    return (
        <section className="home-welcome-hero" aria-label="Bienvenue" data-tour="home-welcome-hero">
            <div className="home-welcome-hero__glow" aria-hidden="true" />
            <div className="home-welcome-hero__content">
                <div className="home-welcome-hero__icon-wrap" aria-hidden="true">
                    {finished ? FINAL_ICON : HERO_ICON}
                </div>
                <div className="home-welcome-hero__copy">
                    <div className="home-welcome-hero__headline">
                        <p className="home-welcome-hero__line" aria-hidden={finished}>
                            <span className="home-welcome-hero__prefix">{PREFIX}</span>
                            <span className="home-welcome-hero__role-slot">
                                <span className="home-welcome-hero__role">{typedWord}</span>
                                {showQuestionSuffix ? (
                                    <span className="home-welcome-hero__suffix">?</span>
                                ) : null}
                                <span className="home-welcome-hero__cursor" aria-hidden="true">|</span>
                            </span>
                        </p>
                        <p className="home-welcome-hero__final" aria-hidden={!finished}>
                            {FINAL_MESSAGE}
                        </p>
                    </div>
                </div>
            </div>
            <ul className="home-welcome-hero__advantages">
                {PLATFORM_ADVANTAGES.map((advantage) => (
                    advantage.type === "typewriter" ? (
                        <AdvantageTypewriterLine
                            key={advantage.prefix}
                            prefix={advantage.prefix}
                            words={advantage.words}
                            icon={advantage.icon}
                        />
                    ) : (
                        <li key={advantage.label} className="home-welcome-hero__advantage">
                            <span className="home-welcome-hero__advantage-icon">{advantage.icon}</span>
                            <span className="home-welcome-hero__advantage-label">{advantage.label}</span>
                        </li>
                    )
                ))}
            </ul>
        </section>
    );
}
